<dashboard-filters [widgetData]="config.data" (filterChanged)="handleFilterUpdate($event)"></dashboard-filters>

<div class="pbi-wrapper">

  @if (isEmbedLoading) {
    <div class="pbi-loader-overlay"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.9); z-index: 10; display: flex; align-items: center; justify-content: center; flex-direction: column;">
      <div class="spinner" style="border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite;"></div>
      <p style="margin-top: 10px; color: #666;">Loading Report...</p>
    </div>
  }

  @if (config.data && config.data.token) {
    <div id="powerbi-container"></div>
  }

</div>